import { Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DroplistWidget } from '@eforall/dashboard';
import { AdmissionsOverviewService } from '../admissions-overview.service';
import { AdmissionsOverviewViewPart } from './overview/overview-view.part';
@Component({
	selector: 'admissions-overview-views-part',
	standalone: true,
	imports: [
		AdmissionsOverviewViewPart,
		DroplistWidget
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './overview-views.part.html',
})
export class AdmissionsOverviewViewsPart implements OnInit {
	public service = inject(AdmissionsOverviewService);

	ngOnInit() {
		this.service.initializeUrl();
	}
}